import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SidebarItem, SidebarSection } from '@app/app/shared/models/sidebar/sidebar.model';
import { LucideBookOpen, LucideChevronDown, LucideChevronLeft } from '@lucide/angular';

@Component({
  selector: 'ptl-sidebar-sections',
  templateUrl: './sidebar-sections.component.html',
  styleUrls: ['./sidebar-sections.component.scss'],
})
export class SidebarSectionsComponent {
  @Input() sections: SidebarSection[] = [];

  @Output() itemClick = new EventEmitter<{ item: SidebarItem; event: Event }>();

  protected readonly LucideChevronLeft = LucideChevronLeft;
  protected readonly LucideChevronDown = LucideChevronDown;
  protected readonly LucideBookOpen = LucideBookOpen;

  constructor(private router: Router) {}

  onItemClick(event: Event, item: SidebarItem): void {
    if (item.isBackButton && item.url) {
      event.preventDefault();
      event.stopPropagation();
      this.router.navigateByUrl(item.url);
      return;
    }

    this.itemClick.emit({ item, event });
  }

  isRouteActive(route: string): boolean {
    return this.router.isActive(route, { paths: 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' });
  }

  hasActiveChild(item: SidebarItem): boolean {
    return !!item.children?.some((child) => child.isActive || (child.url && this.isRouteActive(child.url)));
  }

  toggleExpand(event: Event, item: SidebarItem): void {
    event.preventDefault();
    event.stopPropagation();
    item.expanded = !item.expanded;
  }
}
